import {
	useMutation,
	UseMutationResult,
	useQueryClient
} from '@tanstack/react-query';
import { HttpResponseSuccess } from '@/services/service';
import { useDispatch } from 'react-redux';
import { dashboardGetListsRequest } from '@/modules/dashboard/dashboardActions';
import {
	generateOnboardingList,
	OnboardingListPayload,
	OnboardingListResponse,
	ONBOARDING_LIST_QUERY_KEY
} from '@/services/onboardingListService';

export type { OnboardingListResponse, OnboardingListPayload };
export { ONBOARDING_LIST_QUERY_KEY };

export const useCreateOnboardingList = (): UseMutationResult<
	HttpResponseSuccess<OnboardingListResponse>,
	Error,
	OnboardingListPayload
> => {
	const queryClient = useQueryClient();
	const dispatch = useDispatch();

	return useMutation({
		mutationFn: generateOnboardingList,
		onSuccess: responseData => {
			queryClient.setQueryData(ONBOARDING_LIST_QUERY_KEY, responseData);
			// Refresh the lists in Redux after successful update
			dispatch(dashboardGetListsRequest());
		},
		onError: error => {
			throw new Error('Error creating user onboarding list:', error);
		}
	});
};
